import React, { useEffect, useState } from "react";
import Navbar from "../../global/Navbar";
import { MdLabelImportant, MdArrowRight } from "react-icons/md";
import TestQuestion from "../Test/TestQuestion";
import { franchiseSteps, qsSmartSchoolFranchiseData } from "../../demodata/SmartSchool";
import { fetchEvaluation } from "../../api/Evaluation";
import EditorRenderer from "../EditorRenderer";

const SmartSchool = () => {
  const [evaluation, setEvaluation] = useState([]);
  const [parsedBlocks, setParsedBlocks] = useState([]);

  useEffect(() => {
    const getEvaluation = async () => {
      const data = await fetchEvaluation();
      setEvaluation(data);
    };
    getEvaluation();
  }, []);

 const evaluationFilter = evaluation.filter(
    (item) => item.category?.name.toLowerCase() === "smartschool"
  );

useEffect(() => {
  if (!parsedBlocks.length && evaluationFilter.length) {
    let blocksArray = [];
    try {
      const raw = evaluationFilter[0]?.description;
      if (raw) {
        const outer = JSON.parse(raw);
        const inner = outer[0];
        if (inner?.blocks && Array.isArray(inner.blocks)) {
          blocksArray = inner.blocks;
        }
      }
    } catch (err) {
      console.error("Parsing error:", err);
    }

    setParsedBlocks(blocksArray);
  }
}, [evaluationFilter, parsedBlocks.length]);

 

  return (
    <div className="w-full flex flex-col justify-center items-center bg-[#101e2b]">
      <Navbar />
      <div className="container flex flex-col gap-4 px-4 lg:px-0 mb-20  mt-16">
       
        {parsedBlocks.length > 0 && <EditorRenderer blocks={parsedBlocks} />}

        <div className="flex gap-4 items-center mb-16">
          <p className="text-gray-300 text-xl">
            অথবা WhatsApp করুন– <strong className="text-[#22BEFF]">01711055752</strong>
          </p>
          <button
            className="px-5 py-2 text-base border border-[#22beff] text-[#22beff] hover:text-[#081a28] hover:bg-[#22beff] rounded-md font-bold"
            onClick={() => window.open("https://forms.gle/MWgJ4zyJh3nDr6YdA", "_blank")}
          >
            অ্যাপয়েন্টমেন্ট
          </button>
        </div>

        <TestQuestion questionData={qsSmartSchoolFranchiseData} />
      </div>
    </div>
  );
};

export default SmartSchool;
